export default __webpack_public_path__ + "static/media/logo.8c0a7653.png";